/**
 * Typical SBA 7(a) acquisition terms used to prefill deal models and to
 * estimate whether a listing can be financed. These are starting points the
 * acquirer edits, shown as "typical — check with your lender"; they are not
 * underwriting rules. Update them here only.
 */
export const SBA_DEFAULTS = {
  /** Prime + 2.75%, the usual cap for loans over $350K. */
  interestRate: 0.105,
  /** Business acquisitions without real estate amortise over 10 years. */
  termYears: 10,
  /** Minimum buyer equity injection on a change of ownership. */
  equityInjectionPct: 0.1,
  /**
   * Upfront guarantee fee, financed into the loan. Tiered by loan size and
   * charged on the guaranteed portion; 3% of the loan is a rough middle.
   */
  guaranteeFeePct: 0.03,
  /** Debt service coverage most lenders require. */
  minDscr: 1.25,
  /** Cash-flow drop used for the stress test. */
  stressPct: 0.15,
  /**
   * A seller note on full standby for the whole SBA term can count toward
   * the equity injection, up to this share of the required injection.
   */
  standbyNoteInjectionShare: 0.5,
  /** SBA 7(a) change-of-ownership loans can't include an earnout. */
  earnoutAllowed: false,
} as const;

/** Prefill values for the rest of a deal model; all editable. */
export const DEAL_MODEL_DEFAULTS = {
  /** Legal, lender and diligence costs as a share of the price. */
  closingCostsPct: 0.03,
  sellerNoteRate: 0.06,
  sellerNoteTermYears: 5,
  otherDebtRate: 0.09,
  otherDebtTermYears: 7,
  holdYears: 5,
} as const;
